export class Aggregation {
  name: string
  type: string
  subAggregations: Aggregation[]

  constructor(name: string, type: string) {
    this.name = name
    this.type = type

    this.subAggregations = []
  }

  addAggregation(agg: Aggregation) {
    this.subAggregations.push(agg)
  }
}

export class FieldAggregation extends Aggregation {
  field: string

  constructor(name: string, type: string, field: string) {
    super(name, type)
    this.field = field
  }
}

export class DateAggregation extends FieldAggregation {
  interval: string
  offset: number
  showEmpty: boolean
  min_doc_count: number
  minBound: number
  maxBound: number
  timezone: string

  constructor(name: string, interval: string, offset: number) {
    super(name, 'date_histogram', '@timestamp')
    this.interval = interval
    this.offset = offset
    this.showEmpty = true
    this.min_doc_count = 0
    this.minBound = null
    this.maxBound = null
  }
}

export class MetricAggregation extends FieldAggregation {
  operation: string

  constructor(name: string, field: string, operation: string) {
    super(name, 'metric', field)
    this.operation = operation
  }
}

export class TermsAggregation extends FieldAggregation {
  size: number
  missing: string
  showEmpty: boolean

  constructor(name: string, field: string, size: number) {
    super(name, 'terms', field)
    this.size = size
    this.showEmpty = false
  }
}

export class HistogramAggregation extends FieldAggregation {
  interval: number
  missing: number

  constructor(name: string, field: string, interval: number) {
    super(name, 'histogram', field)
    this.interval = interval
  }
}

export interface Source {
  field: string
  missingBuckets?: boolean
}

export class CompositeAggregation extends Aggregation {
  sources: Source[] = []
  after: any
  size: number

  constructor(name: string, fields: Source[], size: number) {
    super(name, 'composite')
    this.sources = fields
    this.size = size
  }
}
